import { colors } from '@packages/style/colors';
import { ThemeConfiguration } from '@packages/style/themes';
import { FONTS } from './fonts';

export const THEME_CONFIG: ThemeConfiguration = {
    fonts: FONTS,
    colors,
};
